module.exports = __webpack_public_path__ + "img/success.ed2cb36b.png";